import React from 'react';
import { MapGeneralController } from 'src/feature-app';
import { JourneyLeadInPageController } from '.';

export const JourneyLeadsInPageWrapper = () => {
	return (
		<MapGeneralController>
			<JourneyLeadInPageController />
		</MapGeneralController>
	);
};
